import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableHsCodesFetchingForAll = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableHsCodesFetchingForAll);
};
